import { Button, Text } from '@village/ui';
import { millisecondsToMinutes } from 'date-fns';
import { useCountly } from 'epion-checkin/hooks/use-countly';
import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from './styles';

interface Props {
    onStart: () => void;
}

export const Welcome: FC<Props> = ({ onStart }) => {
    const { t } = useTranslation();
    const { addCountlyEvent } = useCountly();
    const durationStartRef = useRef<number>(Date.now());

    useEffect(() => {
        addCountlyEvent({ key: 'viewwelcome' });
    }, [addCountlyEvent]);

    const onGetStarted = () => {
        addCountlyEvent({
            key: 'viewwelcome.clickgetstarted',
            segmentation: {
                duration: millisecondsToMinutes(Date.now() - durationStartRef.current) || 1,
            },
        });

        onStart();
    };

    return (
        <Styled.Container>
            <Text type="h4" fontWeight={700}>
                {t('welcome.title')}
            </Text>
            <Button onClick={onGetStarted}>{t('welcome.getStarted')}</Button>
        </Styled.Container>
    );
};
